import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createArchive } from "../../../api/archives.api";
import ArchiveEditor from "../../../components/archive/ArchiveEditor";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const ArchiveLearnCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/archive/learn');
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createArchive('ST', data));
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-archive-big.svg"
        parentMenu={t('common.menu.resources')}
        currentMenu={t('archive.learn.title3')}
      />
      <ArchiveEditor
        codeId="BR0010"
        submit={submit}
      />
    </div>
  );
}

export default ArchiveLearnCreate;
